<div class="w-screen flex flex-column justify-content-between">
  <a></a>

  <div class="grid-404">
    <div class="imagen">
      <div class="img">
        <img src="../../../../../assets/images/404-not-found.png" alt="¡Página no encontrada" />
      </div>
      <div class="text">
        <div>
          <h2><b>¡Página no encontrada!</b></h2>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center">
    <!-- <img
      src="../../../../assets/images/logo.png"
      alt="Logo Dirección General de Rentas de Salta"
      class="w-6 sm:w-1"
    /> -->
  </div>
</div>
